import { useContext, useState, useRef, useEffect } from "react"
import Button from "react-bootstrap/esm/Button"
import ListListings from "../components/mainpage/ListListings"
import MapContainer from "../components/mainpage/Map"
import { useListingsContext } from "../context/ListingsContext"
import ModalWrapper from "../components/ModalWrapper"
import InputListing from "../components/InputListing"
import { AuthContext } from "../context/AuthContext"
import AddressAutocompleteProvider from "../components/helperComponents/AddressAutocompleteProvider"
import { placeholder } from "@cloudinary/react"
import { sendEmailVerification } from "firebase/auth";
import ListingsSkeleton from "../components/ListingsSkeleton"

const Home = () => {
    const [inputListingOpen, setInputListingOpen] = useState(false)
    const [search, setSearch] = useState("")
    const [categoryFilter, setCategoryFilter] = useState("All")
    const [locationFilter, setLocationFilter] = useState("")
    const { currentUser, authUser } = useContext(AuthContext)

    const [countdown, setCountdown] = useState(0);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        let timer;
        if (countdown > 0) {
            timer = setTimeout(() => setCountdown(countdown - 1), 1000);
        }
        return () => clearTimeout(timer);
    }, [countdown]);

    const handleResendVerification = async () => {
        if (authUser) {
            setLoading(true)
            try {
                await sendEmailVerification(authUser);
                setCountdown(60)
                alert("Verification email sent! If you don't see it, be sure to check your junk/spam folder.");
            } catch (error) {
                if (error.code === 'auth/too-many-requests') {
                    alert("Too many attempts. Please wait a moment before trying again.");
                } else {
                    console.error(error.message);
                }
            } finally {
                setLoading(false);
            }   
        } else {
            alert("No user is currently signed in.");
        }
    };

    const containerRef = useRef(null)
    const getListings = useListingsContext().getListings
    const hasMore = useListingsContext().hasMore
    const setHasMore = useListingsContext().setHasMore
    const setLastVisible = useListingsContext().setLastVisible
    const setListings = useListingsContext().setListings
    const searchListings = useListingsContext().searchListings

    const handleDropdownChange = (e) => {
        setCategoryFilter(e.target.value)
    }

    const [formKey, setFormKey] = useState(0)
    const clearFilters = () => {
        setSearch("")
        setCategoryFilter("All")
        setLocationFilter("")
        setListings([])
        setHasMore(true)
        setLastVisible(null)
        setFormKey(prevKey => prevKey + 1)
    }

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting && hasMore) {
                    console.log(entries)
                    if (search || categoryFilter || locationFilter) {
                        const zipFromLocationFilter = locationFilter.split(",")[0]
                        getListings(search, categoryFilter, zipFromLocationFilter)
                    } 
                    else {
                        getListings()
                    }
                }
            },
            {
                root: null, // Use the viewport as the root
                rootMargin: '400px 0px 0px 0px',
                threshold: 0, // Trigger when 80% of the element is visible
            }
        );

        if (containerRef.current) {
            observer.observe(containerRef.current);
        }

        return () => {
            if (containerRef.current) {
                observer.unobserve(containerRef.current);
            }
        };
    }, [hasMore, getListings]);

    return (
        <div className='home-container grid-container'>
            {
                currentUser ?
                <ModalWrapper
                    show={inputListingOpen}
                    onHide={() => setInputListingOpen(false)}
                    heading="Create Listing"
                >
                    <InputListing 
                        disabled={!currentUser.emailVerified}
                    />
                </ModalWrapper>:
                <></>
            }
            <div className="page-container">
                {currentUser && !currentUser.emailVerified ? 
                    <div className='alert alert-danger'>
                        <>
                            Please verify your e-mail to unlock full access to Phreesh!
                        </>
                        <Button variant="light" onClick={handleResendVerification} 
                            disabled={countdown > 0 || loading}
                            className={`btn ${countdown > 0 ? 'opacity-50 cursor-not-allowed' : 'text-blue-600'}`}
                            // className="text-blue-600 underline"
                        >
                            {countdown > 0 
                                ? `Resend in ${countdown}s` 
                                : loading ? "Sending..." : "Resend verification email"
                            }
                            {/* Resend verification email */}
                        </Button>
                    </div>:
                    <></>
                }
                <div className="home-content page-content">
                    <div className="listings-div">
                        <div className="page-header">
                            <span className="header-text">
                                Listings
                            </span>
                            {
                                currentUser ?
                                <Button className="new-listing-button" variant="primary" onClick={() => setInputListingOpen(true)}>
                                    New Listing
                                </Button> 
                                :
                                <></>
                            }
                            {/* <div>
                                <label htmlFor="category-filter" className="text-sm font-semibold text-gray-600 mb-1">
                                    Category
                                <select
                                    id="category-filter"
                                    type="text"    
                                    className="form-input"
                                    onChange={
                                        e=> setCategoryFilter(e.target.value)
                                    }
                                >
                                    <option value="">All</option>
                                    <option value="Home and Kitchen">Home and Kitchen</option>
                                    <option value="Electronics">Electronics</option>
                                    <option value="Women's Clothing and Accessories">Women's Clothing and Accessories</option>
                                    <option value="Men's Clothing and Accessories">Men's Clothing and Accessories</option>
                                    <option value="Baby and Kids">Baby and Kids</option>
                                    <option value="Auto Parts and Accessories">Auto Parts and Accessories</option>
                                    <option value="Sports and Fitness">Sports and Fitness</option>
                                    <option value="Tools and Garden">Auto Parts and Accessories</option>
                                    <option value="Other">Other</option>
                                </select>
                                </label>
                            </div> */}
                            <div className="query-forms">
                                <div className="dropdown" key={formKey}>
                                    <Button className="dropdown-toggle" href="#" data-bs-toggle="dropdown" aria-expanded="false">Filters</Button>
                                    {/* <img src={currentUser.avatarUrl ? currentUser.avatarUrl : img1} className="avatar avatar-nav nav-item dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false"/> */}
                                    <div className="dropdown-menu filter-menu" id="dropdown-menu">
                                        <form className="filter-form">
                                            <input type="search" className="form-input" onChange={e => setSearch(e.target.value)} placeholder="Search"></input>
                                            <AddressAutocompleteProvider address={locationFilter} setAddress={setLocationFilter} 
                                                options={
                                                    {types:['postal_code', 'neighborhood', 'sublocality_level_1'],
                                                    fields: ['geometry', 'name', 'formatted_address', 'address_components']}
                                                }
                                                placeholder={"Enter a Neighborhood"}
                                            />
                                            {/* <input type="search" className="form-input" onChange={e => setLocationFilter(e.target.value)} placeholder="Location"></input> */}
                                            <label htmlFor="category-filter" className="text-sm font-semibold text-gray-600 mb-1">
                                                Category
                                                <select
                                                    id="category-filter"
                                                    type="text"    
                                                    className="form-input"
                                                    onChange={e => setCategoryFilter(e.target.value)}
                                                    
                                                >
                                                    <option value="All">All</option>
                                                    <option value="Home and Kitchen">Home and Kitchen</option>
                                                    <option value="Electronics">Electronics</option>
                                                    <option value="Women's Clothing and Accessories">Women's Clothing and Accessories</option>
                                                    <option value="Men's Clothing and Accessories">Men's Clothing and Accessories</option>
                                                    <option value="Baby and Kids">Baby and Kids</option>
                                                    <option value="Auto Parts and Accessories">Auto Parts and Accessories</option>
                                                    <option value="Sports and Fitness">Sports and Fitness</option>
                                                    <option value="Tools and Garden">Auto Parts and Accessories</option>
                                                    <option value="Other">Other</option>
                                                </select>
                                            </label>
                                            <input type="submit" className="btn btn-primary" value="Filter"
                                                    onClick={
                                                        (e) => {
                                                            e.preventDefault()
                                                            console.log(search)
                                                            console.log(categoryFilter)
                                                            console.log(locationFilter)
                                                            setListings([])
                                                            setHasMore(true)
                                                            setLastVisible(null)
                                                            //search is conducted via useEffect when hasMore changes
                                                        }
                                                    }
                                            />
                                            <Button onClick={clearFilters}>Clear</Button>
                                        </form>
                                    </div>
                                </div>

                                <form className="search-form">
                                    <input type="search" className="form-input search-bar" onChange={e => setSearch(e.target.value)} placeholder="Search"></input>
                                    <input type="submit" className="search-button" value=""
                                        onClick={
                                            (e) => {
                                                e.preventDefault()
                                                console.log(search)
                                                setListings([])
                                                setHasMore(true)
                                                setLastVisible(null)
                                                //search is conducted via useEffect when hasMore changes
                                            }
                                        }
                                    />
                                </form>
                            </div>
                        </div>
                        {/* <div className="list-listings-container">
                            <ListListings listings={useListingsContext().listings}/>
                            <div ref={containerRef} className="intersection"></div>
                            {useListingsContext().listings==null && <ListingsSkeleton/>}
                        </div> */}
                        <ListListings listings={useListingsContext().listings} search={search} categoryFilter={categoryFilter} locationFilter={locationFilter}/>
                    </div>
                    <MapContainer />
                </div>
            </div>

        </div>
    )
}

export default Home